module.exports = __webpack_public_path__ + "h5/img/support.b1eaa502.png";